import { LogoOptions } from './logo-options';
import { PlanetMediaPlayerSetup } from './planet-media-player-setup';
import { CaptionsOptions, CastOptions, MediaItem, SkinOptions } from './setup';

/**
 * @class
 * @implements PlanetMediaPlayerSetup
 * @inheritDoc
 */
export class MediaPlayerSettings implements PlanetMediaPlayerSetup {

    /**
     * @inheritDoc
     */
    overrideNative?: boolean;

    useNativeTextTracks?: boolean;
    useNativeVideoTracks?: boolean;
    useNativeAudioTracks?: boolean;

    /**
     * @inheritDoc
     */
    videojs?: any;

    /**
     * @inheritDoc
     */
    enableLowInitialPlaylist?: boolean = false;

    /**
     * @inheritDoc
     */
    limitRenditionByPlayerDimensions?: boolean = false;

    /**
     * @inheritDoc
     */
    fill?: boolean;

    aboutlink?: string;

    abouttext?: string;

    aspectratio?: string;
    audioOnly?: boolean;
    autostart?: boolean | 'viewable';
    base?: string;
    captions?: CaptionsOptions;
    cast?: CastOptions;
    controls?: boolean;
    defaultBandwidthEstimate?: number;
    displayPlaybackLabel?: boolean;
    displaydescription?: boolean;
    displaytitle?: boolean;
    file?: string;
    flashplayer?: string;
    height?: number | string;
    hlsjsdefault?: boolean;
    image?: string;
    key?: string;
    listeners?: { [p: string]: () => void };
    liveTimeout?: number;
    logo?: LogoOptions;
    loop?: boolean;
    metadata?: { [p: string]: string };
    mute?: boolean;
    nextUpDisplay?: boolean;
    nextupoffset?: number;
    panoramic?: boolean;
    playbackRateControls?: boolean;
    playbackRates?: number[];
    playlist?: MediaItem[];
    preload?: 'none' | 'metadata' | 'auto';
    qualityLabels?: { [p: string]: string }[];
    renderCaptionsNatively?: boolean;
    repeat?: boolean;
    skin?: SkinOptions;

    auth?: { token: string };

    set startAt(value: number) {
        this.starttime = value;
    }

    get startAt(): number {
        return this.starttime;
    }

    set startTime(value: number) {
        this.starttime = value;
    };

    get startTime(): number {
        return this.starttime;
    };

    starttime?: number;
    stretching?: 'uniform' | 'exactfit' | 'fill' | 'none';
    width?: number | string;

    onXhr?(options: any): void {
    }
}
